"use client";

import * as React from "react";
import { ResponsiveContainer } from "recharts";
import { cn } from "@/lib/utils";

// CargoFL ShadCN Library — ChartContainer (recharts ResponsiveContainer).
export type ChartConfig = Record<
  string,
  {
    label?: React.ReactNode;
    color?: string;
  }
>;

export interface ChartContainerProps {
  config?: ChartConfig;
  className?: string;
  children: React.ReactElement;
}

const ChartContainer = React.forwardRef<HTMLDivElement, ChartContainerProps>(
  ({ config, className, children }, ref) => {
    const chartVars = React.useMemo(() => {
      const vars: Record<string, string> = {
        "--chart-1": "var(--chart-1)",
        "--chart-2": "var(--chart-2)",
        "--chart-3": "var(--chart-3)",
        "--chart-4": "var(--chart-4)",
        "--chart-5": "var(--chart-5)",
      };
      if (config) {
        for (const [key, item] of Object.entries(config)) {
          if (item.color) {
            vars[`--color-${key}`] = item.color;
          }
        }
      }
      return vars as React.CSSProperties;
    }, [config]);

    return (
      <div
        ref={ref}
        style={chartVars}
        className={cn(
          "flex aspect-video justify-center text-xs text-muted-foreground",
          className
        )}
      >
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>
    );
  }
);
ChartContainer.displayName = "ChartContainer";

export { ChartContainer };
